import * as ActionType from 'constants/action-types/organization';

export default (state, { type, payload }) => {
  switch (type) {
    case ActionType.ADD_BULK_PAYMENT_RECIPIENT_START:
      return {
        ...state,
        addBulkPaymentRecipient: {
          ...state.addBulkPaymentRecipient,
          loading: true,
          error: null,
        },
      };
    case ActionType.ADD_BULK_PAYMENT_RECIPIENT_SUCCESS:
      return {
        ...state,
        addBulkPaymentRecipient: {
          ...state.addBulkPaymentRecipient,
          data: payload,
          error: null,
          loading: false,
        },
      };
    case ActionType.ADD_BULK_PAYMENT_RECIPIENT_ERROR:
      return {
        ...state,
        addBulkPaymentRecipient: {
          ...state.addBulkPaymentRecipient,
          data: payload,
          error: null,
          loading: false,
        },
      };

    default:
      return null;
  }
};
